import { render } from "./Header_coop.vue?vue&type=template&id=3c68e2c3"
import script from "./Header_coop.vue?vue&type=script&lang=js"
export * from "./Header_coop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__